<mat-card class="note-cards">
  <mat-card-title>
    <div class="modified-by-title">
      <div class="modified-info-title">
        <div class="hidden-title-label">
          Last Modified By:
        </div>
        <!--<div>{{note?.modifiedDate | date:'medium'}}</div>-->
        <!--<div>by {{note?.modifiedByUser?.fullName}}  </div>-->
      <div>{{note?.modifiedByUser?.fullName}}</div>
      </div>
    </div>
    <div class="modified-by-title">
      <div class="modified-info-title">
        <div class="hidden-title-label">
          Created By:
        </div>
        <!--<div>{{note?.createdDate | date:'medium'}}</div>-->
        <!--<div>by {{note?.createdByUser?.fullName}}  </div>-->
      <div>{{note?.createdByUser?.fullName}}</div>
      </div>
    </div>
  </mat-card-title>
  <mat-divider inset></mat-divider>
  <mat-card-content>
    <div [ngClass]="{'pre-text-fields-shrunk': shrinkNotes, 'pre-text-fields': !shrinkNotes }">
      <div *ngIf="!note?.editMode" class="pre-text-fields">
<span>{{note?.note}}</span> <!--Do not format the HTML, this will alter the diplay when renederd in the browser-->
      </div>
    </div>
    <div *ngIf="note?.editMode">
      <textarea class="text-area-field" matInput [(ngModel)]="note.note" placeholder="Enter daily note here.">{{note?.note}}</textarea>
    </div>
  </mat-card-content>
  <mat-divider ></mat-divider>
  <mat-card-actions *ngIf="!readOnly">
    <button mat-button *ngIf="!note?.editMode" (click)="note.editMode = true;">Edit</button>
    <button mat-button *ngIf="note?.editMode" (click)="note.editMode = false;">Cancel</button>
    <button mat-button *ngIf="note?.editMode" (click)="deleteNote(note)">Delete</button>
    <button mat-button *ngIf="note?.editMode" (click)="saveNote(note)">Save</button>
  </mat-card-actions>
</mat-card>

